import {
  LEARNING_MODALITIES,
  type LearningMaterial,
  type LearningModality,
  type SiteLearningWorkspace,
} from '@common/domain/learning-workspace';

export type LearningRouteResolution =
  | { kind: 'ready'; modality: LearningModality; materials: readonly LearningMaterial[]; scopedChapterSlug?: string }
  | { kind: 'unavailable'; reason: 'workspace_disabled' | 'persona_mismatch' | 'modality_invalid' | 'chapter_unavailable' };

export function resolveLearningRoute(
  workspace: SiteLearningWorkspace,
  input: { personaSlug?: string; modality?: string; chapterSlug?: string },
): LearningRouteResolution {
  if (!workspace.enabled) {
    return { kind: 'unavailable', reason: 'workspace_disabled' };
  }
  if (input.personaSlug !== workspace.persona.slug) {
    return { kind: 'unavailable', reason: 'persona_mismatch' };
  }
  if (!input.modality || !LEARNING_MODALITIES.includes(input.modality as LearningModality)) {
    return { kind: 'unavailable', reason: 'modality_invalid' };
  }

  const materials = workspace.materials.filter((material) => material.enabled);
  if (input.chapterSlug) {
    const material = materials.find((candidate) => candidate.slug === input.chapterSlug);
    if (!material) {
      return { kind: 'unavailable', reason: 'chapter_unavailable' };
    }
    return {
      kind: 'ready',
      modality: input.modality as LearningModality,
      materials: [material],
      scopedChapterSlug: input.chapterSlug,
    };
  }

  return { kind: 'ready', modality: input.modality as LearningModality, materials };
}
